<div class="tab-button-wrapper">
  <button
    class="tab-button"
    [class.tab-button--selected]="isSelected"
    [class.tab-button--unselected]="!isSelected"
    [ngStyle]="tabStyles | theme"
    (click)="onClick($event)"
  >
    @if (splicedBg) {
      <app-spliced-background [image]="splicedBg.imageUrl" [cornerSize]="splicedBg.cornerSize" />
    }
    <span class="tab-button__label">{{ label }}</span>
    @if (pendingCount) {
      <span class="tab-button__pending-count">{{ pendingCount }}</span>
      <app-icon
        class="tab-button__pending-icon"
        icon="hourglass"
        colorCss="--tab-pending-icon-color"
        sizeCss="--icon-small"
      />
    }
  </button>
  @if (showDot) {
    <span class="tab-button__pending-dot" aria-hidden="true"></span>
  }
</div>
